import type { ReactNode } from 'react'
import React from 'react'

import { Dashboard, PageLayout } from '@components/common'
import { SettingsTabs } from '@components/common/SettingsTabs'
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { HeadContent } from '@fourthwall/components'
import {
  BadgeFilledIcon,
  BadgeIcon,
  CartFilledIcon,
  CartIcon,
  CogFilledIcon,
  CogIcon,
  EmoteFilledIcon,
  EmoteIcon,
  MessagesFilledIcon,
  MessagesIcon,
  MobileAppFilledIcon,
  MobileAppIcon,
  WelcomePostFilledIcon,
  WelcomePostIcon,
} from '@fourthwall/icons'
import { routing } from '@utils/routing'

export const Settings = ({ element }: { element: ReactNode }) => {
  const { hasPermission } = useDashboardPermissions()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const tabs = [
    {
      name: 'General',
      path: routing.memberships.settings.general,
      icon: CogIcon,
      activeIcon: CogFilledIcon,
      hidden: !hasPermission('memberships.settings.general'),
    },
    {
      name: 'Messages',
      path: routing.memberships.settings.messages,
      icon: MessagesIcon,
      activeIcon: MessagesFilledIcon,
      hidden:
        !dashboardFeatureFlags.membershipsMessages.enabled ||
        !hasPermission('memberships.settings.messages'),
    },
    {
      name: 'Badges',
      path: routing.memberships.settings.badges.self,
      icon: BadgeIcon,
      activeIcon: BadgeFilledIcon,
      hidden: !hasPermission('memberships.settings.badges'),
    },
    {
      name: 'Custom emoji',
      path: routing.memberships.settings.customEmoji,
      icon: EmoteIcon,
      activeIcon: EmoteFilledIcon,
      hidden:
        !dashboardFeatureFlags.membershipsCustomEmoji.enabled ||
        !hasPermission('memberships.settings.customEmoji'),
    },
    {
      name: 'Welcome post',
      path: routing.memberships.settings.welcomePost,
      icon: WelcomePostIcon,
      activeIcon: WelcomePostFilledIcon,
      hidden: !hasPermission('memberships.settings.welcomePost'),
    },
    {
      name: 'Mobile app',
      path: routing.memberships.settings.mobileApp,
      icon: MobileAppIcon,
      activeIcon: MobileAppFilledIcon,
      hidden:
        dashboardFeatureFlags.membershipsWla.enabled ||
        !hasPermission('memberships.settings.mobileApp'),
    },
    {
      name: 'Shop upselling',
      path: routing.memberships.settings.upselling,
      icon: CartIcon,
      activeIcon: CartFilledIcon,
      hidden: !hasPermission('memberships.settings.upselling'),
    },
  ].filter(({ hidden }) => !hidden)

  return (
    <PageLayout size="medium">
      <HeadContent title="Memberships settings" />
      <Dashboard.Section name="Memberships settings" bottomMargin="large">
        <SettingsTabs tabs={tabs} element={element} />
      </Dashboard.Section>
    </PageLayout>
  )
}
